export const applyOpacityOnStyleParamsColors = (appSettings, stylesParam) => {
  const styleParamsColorsWithOpacity = {};
  Object.keys(stylesParam.colors || {}).forEach(colorKey => {
    // @ts-expect-error
    styleParamsColorsWithOpacity[colorKey] = {
      ...stylesParam.colors[colorKey],
      value: appSettings[colorKey] ? mergeOpacityToColor(appSettings[colorKey].value, stylesParam.colors[colorKey].value) : stylesParam.colors[colorKey].value
    };
  });
  return styleParamsColorsWithOpacity;
};
const mergeOpacityToColor = (sourceColor, destinationColor) => {
  if (sourceColor.startsWith('rgba') && destinationColor.startsWith('rgb')) {
    if (destinationColor.startsWith('rgba')) {
      const splitDestinationColorToRGB = destinationColor.substring(5, destinationColor.length - 1).split(',');
      const splitSourceColorToRGB = sourceColor.substring(5, sourceColor.length - 1).split(',');
      splitDestinationColorToRGB.pop();
      splitDestinationColorToRGB.push(splitSourceColorToRGB.pop());
      return `rgba(${splitDestinationColorToRGB.join(',')})`;
    } else {
      const splitDestinationColorToRGB = destinationColor.substring(4, destinationColor.length - 1).split(',');
      const splitSourceColorToRGB = sourceColor.substring(5, sourceColor.length - 1).split(',');
      splitDestinationColorToRGB.push(splitSourceColorToRGB.pop());
      return `rgba(${splitDestinationColorToRGB.join(',')})`;
    }
  }
  return destinationColor;
};
//# sourceMappingURL=mergeOpacity.js.map